import features from '~/config/features.cjs'

export default function ({ app, route, redirect }) {
  const path = route.path.replace(/^\/en(?=\/|$)/, '')
  if (!features.payments && /^\/(?:current-user|welcome)\/payments(?:\/|$)/.test(path)) {
    return redirect(302, app.localePath('/users'))
  }
}
